"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.primaryFont = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _colors = _interopRequireDefault(require("./colors"));

var primaryFont = {
  fontSize: '16px',
  fontFamily: 'Source Sans Pro',
  fontWeight: '500',
  lineHeight: '24px',
  '-webkit-font-smoothing': 'antialiased'
}; // a copy of `primaryFont` for `styled-components`

exports.primaryFont = primaryFont;
var primaryFontStyle = "\n    font-size: ".concat(primaryFont.fontSize, ";\n    font-family: ").concat(primaryFont.fontFamily, ";\n    font-weight: ").concat(primaryFont.fontWeight, ";\n    line-height: ").concat(primaryFont.lineHeight, ";\n    letter-spacing: ").concat(primaryFont.letterSpacing, ";\n    -webkit-font-smoothing: antialiased;\n");
var primaryColor = _colors["default"].blackberry[600];
var secondaryColor = _colors["default"].lychee[100];
var h1 = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, primaryFont), {}, {
  fontSize: '60px',
  lineHeight: '64px',
  fontWeight: 100
});
var h2 = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, primaryFont), {}, {
  fontSize: '40px',
  lineHeight: '44px',
  fontWeight: 500
});
var h3 = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, primaryFont), {}, {
  fontSize: '32px',
  lineHeight: '36px',
  fontWeight: 400
});
var h4 = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, primaryFont), {}, {
  fontSize: '24px',
  lineHeight: '28px',
  fontWeight: 600
});
var h5 = {
  fontSize: '20px',
  lineHeight: '24px',
  fontWeight: 600
};
var h6 = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, primaryFont), {}, {
  fontSize: '18px',
  lineHeight: '24px',
  fontWeight: 600
});
var subtitle1 = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, primaryFont), {}, {
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: 700
});
var subtitle2 = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, primaryFont), {}, {
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: 600
});
var body1 = (0, _objectSpread2["default"])({}, primaryFont);
var body2 = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, primaryFont), {}, {
  fontSize: '14px',
  lineHeight: '20px'
});
var caption = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, primaryFont), {}, {
  fontSize: '12px',
  lineHeight: '20px'
});
var overline = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, primaryFont), {}, {
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: 700,
  textTransform: 'uppercase'
});
var button = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, primaryFont), {}, {
  color: secondaryColor
});
var _default = {
  primaryFontStyle: primaryFontStyle,
  primaryColor: primaryColor,
  secondaryColor: secondaryColor,
  h1: h1,
  h2: h2,
  h3: h3,
  h4: h4,
  h5: h5,
  h6: h6,
  subtitle1: subtitle1,
  subtitle2: subtitle2,
  body1: body1,
  body2: body2,
  caption: caption,
  overline: overline,
  button: button
};
exports["default"] = _default;